module.exports = __webpack_public_path__ + "static/media/zabawy-na-powietrzu_small.ec582c78.jpg";